import { render, staticRenderFns } from "./VendorRecomendation.vue?vue&type=template&id=0a96ac9c&"
import script from "./VendorRecomendation.vue?vue&type=script&lang=js&"
export * from "./VendorRecomendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports